




















import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { CardProvider, HsabSsoDestination } from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCardProviderOptionsStore } from "@/employee/store/cardProviderOptions";
import * as RouteNames from "@/employee/route-names";

@Component({
  components: {
    SsoDeepLink,
    GenericLoadingSpinner,
  }
})
export default class HsabLinkedAccounts extends Vue {
  hsabAccountStore = useHsabAccountsStore();
  cardProviderOptionsStore = useCardProviderOptionsStore();

  mounted () {
    this.onCardProviderOptionsLoaded();
    this.cardProviderOptionsStore.getCardProviderOptions();
  }

  get isPageLoading () {
    return ! this.cardProviderOptionsStore.isLoaded;
  }

  get hsabBankingCardsDeeplinkLocation () {
    return HsabSsoDestination.BankingCards;
  }

  get headerCopy () {
    return this.hsabAccountStore.debitCardsAvailable ?
      "Your Linked Accounts and Debit Cards" :
      "Your Linked Accounts";
  }

  get bodyCopy () {
    return this.hsabAccountStore.debitCardsAvailable ?
      "View and manage your linked bank accounts and debit cards" :
      "View and manage your linked bank accounts";
  }

  @Watch("cardProviderOptionsStore.isLoaded")
  onCardProviderOptionsLoaded () {
    if (this.cardProviderOptionsStore.isLoaded &&
      this.cardProviderOptionsStore.cardProvider === CardProvider.Fiserv) {
      // redirect the user to the Fiserv UI
      this.$router.replace({ name: RouteNames.DebitCardManagement });
    }
  }
}
